import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getOrderInvoices as getOrderInvoicesApi,
  addNewOrderInvoice as addNewOrderInvoiceApi,
  updateOrderInvoice as updateOrderInvoiceApi,
  deleteOrderInvoice as deleteOrderInvoiceApi,
  getOrderInvoiceByNumber as getOrderInvoiceByNumberApi,
} from "../../helpers/realbackend_helper";

export const getOrderInvoices = createAsyncThunk(
  "orderinvoice/getOrderInvoices",
  async () => {
    try {
      const response = await getOrderInvoicesApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getOrderInvoiceByNumber = createAsyncThunk(
  "orderinvoice/getOrderInvoiceByNumber",
  async (orderinvoice) => {
    try {
      const response = await getOrderInvoiceByNumberApi(orderinvoice);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addNewOrderInvoice = createAsyncThunk(
  "orderinvoice/addNewOrderInvoice",
  async (orderinvoice) => {
    try {
      const response = addNewOrderInvoiceApi(orderinvoice);
      toast.success("Нэхэмжлэх амжилттай бүртгэлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Нэхэмжлэх бүртгэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateOrderInvoice = createAsyncThunk(
  "orderinvoice/updateOrderInvoice",
  async (orderinvoice) => {
    try {
      const response = updateOrderInvoiceApi(orderinvoice);
      toast.success("Нэхэмжлэх амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Нэхэмжлэх засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteOrderInvoice = createAsyncThunk(
  "orderinvoice/deleteOrderInvoice",
  async (id, { rejectWithValue }) => {
    try {
      await deleteOrderInvoiceApi(id);

      toast.success("Нэхэмжлэх амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Нэхэмжлэх устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);
